module.exports = __webpack_public_path__ + "static/img/introduce_heared_01_zh.9fe1185.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduce_heared_01_zh.png
// module id = vfSy
// module chunks = 34